module.exports = __webpack_public_path__ + "static/media/21ECLAC46.c903dfb1.jpg";